import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import Section from 'components/Section';
import TravelDocumentSelect from 'components/TravelDocumentSelect';

import { PackageEditMainDocuments_data$key } from '__generated__/PackageEditMainDocuments_data.graphql';

type Props = {
  data: PackageEditMainDocuments_data$key;
};

const PackageEditMainDocuments = (props: Props) => {
  const data = useFragment(
    graphql`
      fragment PackageEditMainDocuments_data on Query {
        ...TravelDocumentSelect_data
      }
    `,
    props.data
  );

  return (
    <Section id="terms" title="Kelionės dokumentai">
      <Stack spacing={4}>
        <TravelDocumentSelect
          name="documents"
          label="Išvardinkite dokumentus, kuriuos keleiviai turi įkelti prie užsakymo"
          data={data}
        />
      </Stack>
    </Section>
  );
};

export default PackageEditMainDocuments;
